import Stickyfill from "stickyfilljs";

export default class Sticky {

    ready() {

        const ELEMENTS = document.querySelectorAll('.sticky');
        ELEMENTS.length > 0 && Stickyfill.add(ELEMENTS);

    }
}